/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "il-central-1",
    "aws_cognito_identity_pool_id": "il-central-1:e177fe97-c65f-4d26-9c33-4a2c5c411f7f",
    "aws_cognito_region": "il-central-1",
    "aws_user_pools_id": "il-central-1_z5HnNNB9s",
    "aws_user_pools_web_client_id": "7bh10pb8lkdj46mjgf3g3o0s8g",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
